import { apiCall } from "./authServices";

export const getCourseModules = async (courseId) => {
  try {
    const response = await apiCall({
      endpoint: `api/course-modules/get-course-modules/${courseId}`,
      method: "GET",
    });
    return response;
  } catch (error) {
    console.error("Error fetching course modules:", error);
    throw error;
  }
};

export const saveModules = async (formData) => {
  try {
    const response = await apiCall({
      endpoint: "api/course-modules/insert-modules",
      method: "POST",
      payload: formData,
    });
    return response;
  } catch (error) {
    console.error("Error saving modules:", error);
    throw error;
  }
};
